export default __webpack_public_path__ + "static/media/cvxFXS.e33922b9.png";